import React from 'react';
import { Provider } from 'react-redux';
import thunk from "redux-thunk";
import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from "../store/store";
import FilteredPage from './FilteredPage';

const store = createStore(
    rootReducer,
    compose(
      applyMiddleware(
        thunk // lets us dispatch() functions
      )
    )
  )

const FilterContainer = (props) => {
    return (
        <Provider store={store}>
            <FilteredPage apiUrl={props.apiUrl} sortList={props.sortList} defaultSort={props.defaultSort} localisedStrings={props.localisedStrings}>
                    {props.children}
            </FilteredPage>
        </Provider>
    )
}

export default FilterContainer;